<template>
<div class="pt-3">
<div v-if="loading" class="text-center pt-3"><i class="fas fa-spinner fa-spin"></i></div>
<div v-else-if="!product" class="text-center pt-3">Product not found</div>

<div v-else>

<product-admin-bar :user="user" :product="product" @product-reviewed="getProduct()"></product-admin-bar>

<div class="row pt-4">
    <div class="col-md-4 pb-2 pb-md-4">
        <div class="pt-2 pb-md-4">
            <product-images v-if="product.images.length > 0" :product="product"></product-images>
            <img v-else width="100%" src="/images/image-not-found.svg" style="border-radius:8px;" />
        </div>

        <!-- Desktop -->
        <div class="d-none d-md-table w-100">
        <div v-if="product.url" class="text-center pt-3">
        <banner2></banner2>
        </div>
        </div>

    </div>
    <!-- 
    <product-simple v-if="product.url" :product="product" :averageReviews="averageReviews"></product-simple>
    <product-main v-else :logged="logged" :product="product" :averageReviews="averageReviews" :whatsappLink="whatsappLink"></product-main> 
    -->
    <product-main :logged="logged" :product="product" :averageReviews="averageReviews" :whatsappLink="whatsappLink"></product-main>

    <!-- Desktop -->
        <div class="d-none d-md-table w-100">
        <div v-if="product.url" class="text-center pb-4">
        <banner1></banner1>
        </div>
        </div>

    <!-- Mobile -->
    <div class="d-md-none w-100">
    <div v-if="product.url" class="text-center pt-3 px-3">
    <banner2></banner2>
    </div>
    </div>

</div>
</div>
<reviews-modal :product_id="product_id"></reviews-modal>
</div>
</template>

<script>
export default {
  props : ['product_id', 'logged', 'user', 'country'],

  data() {
    return {
      product: {},
      loading: false,
      loading_whatsapp: false,
      whatsappLink: null,
      averageReviews: 0,
    };
  },

  created() {
    this.getProduct();
    this.getWhatsappLink();
  },

  watch: {
    product() {
      this.$nextTick(() => {
        this.setLinks();
      });
    }
  },

  methods: {

    showModalReviews() {
      this.$bvModal.show('bv-modal-reviews');
    },

    getWhatsappLink() {
      this.loading_whatsapp = true;
      axios
        .get('/product/whatsapp/' + this.product_id)
        .then((response) => {
          this.whatsappLink = response.data;
          this.loading_whatsapp = false;
        });
    },

    calculateAverageReviews(reviews) {
      if (!reviews.length) return 0; // Return 0 if no reviews
      
      const totalStars = reviews.reduce((sum, review) => sum + parseFloat(review.stars), 0);
      const averageReviews = totalStars / reviews.length;

      return averageReviews.toFixed(1); // Format to 1 decimal place
    },

    setLinks() {
      this.$nextTick(() => {
        const links = this.$el.querySelectorAll('.product_description a');
        links.forEach(link => {
          link.setAttribute('target', '_blank');
        });
      });
    },

    getProduct() {
      this.loading = true;
      axios
        .get('/product/get/' + this.product_id)
        .then((response) => {
          this.product = response.data;
          this.loading = false;

          // Save product to local storage
          let images = this.product.images.length > 0 ? this.product.images : [{ url: '/images/image-not-found.svg' }];
          let product = {
            id: this.product.id,
            name: this.product.name,
            seller: this.product.seller,
            images: images,
            price: this.product.price,
          };

          this.saveProduct(product);

          this.averageReviews = this.calculateAverageReviews(this.product.reviews);
        });
    },

    saveProduct(product) {
      let maxProducts = 8;
      let products = JSON.parse(localStorage.getItem('history')) || [];
      products = products.filter(p => p.id != product.id);
      products.unshift(product);
      products = products.slice(0, maxProducts);
      localStorage.setItem('history', JSON.stringify(products));
    }
  }
};
</script>

